export default function LessonUnavalible() {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255,255,255,0.6)",
        borderRadius: 20,
      }}>
      <div
        style={{
          padding: 25,
          width: 500,
          backgroundColor: "#fff",
          textAlign: "center",
          borderRadius: 20,
          boxShadow: "0px 5px 10px 2px rgba(34, 60, 80, 0.2)",
        }}>
        <h3>Назначение занятий недоступно</h3>
        <p>
          Необходимо назначить категории и количество часов для пользователя
        </p>
      </div>
    </div>
  );
}
